import { motion } from "framer-motion";
import { Repeat, Target, HandshakeIcon } from "lucide-react";

export function ValueProposition() {
  const features = [
    {
      icon: Repeat,
      title: "Vendor Replacement",
      desc: "Unhappy with your current vendor? We help you find and switch to a better alternative — smoothly and quickly.",
      color: "#dc2626",
    },
    {
      icon: Target,
      title: "Cost Optimization",
      desc: "Our vendor network and bulk buying power help you save up to 30% on every service — without compromising quality.",
      color: "#6366f1",
    },
    {
      icon: HandshakeIcon,
      title: "One-Stop Convenience",
      desc: "Compliance, IT, supplies, manpower — manage all your vendors from a single platform with dedicated support.",
      color: "#10b981",
    },
  ];

  return (
    <section data-testid="value-prop-section" className="py-14 md:py-18 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">
            Who We Are
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-[44px] font-black mt-3 mb-3 tracking-tight">
            Your Partner in Vendor Management
          </h2>
          <p className="text-slate-500 text-base md:text-lg font-body max-w-2xl mx-auto">
            SwitchYourVendor is India's first dedicated platform helping businesses find, compare, and switch to better vendors across compliance, IT, supplies, and manpower.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat, i) => {
            const Icon = feat.icon;
            return (
              <motion.div
                key={feat.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="rounded-3xl p-8 border border-slate-100 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 bg-gradient-to-b from-white to-slate-50"
              >
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                  style={{ background: `${feat.color}10` }}
                >
                  <Icon size={26} style={{ color: feat.color }} />
                </div>
                <h3 className="text-lg font-extrabold text-slate-900 mb-3 font-body">{feat.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed font-body">{feat.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
